var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M46.8387 17.8136H25.3184V8.84424H46.8387V17.8136Z",
    fill: "#8795DE",
    stroke: "#111111",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M62.5274 39.778H25.3184V24.5332H62.5274V39.778Z",
    fill: "#8795DE",
    stroke: "#111111",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_568_",
    d: "M69.8081 17.2512V65.8864C69.8081 68.4858 67.7009 70.593 65.1016 70.593H22.7417C20.1423 70.593 18.0352 68.4858 18.0352 65.8864V6.26906C18.0352 3.66969 20.1423 1.5625 22.7417 1.5625H54.1192",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_560_",
    d: "M69.808 17.2512H54.1191V1.5625L69.808 17.2512Z",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_556_",
    d: "M61.9642 70.5931V73.7309C61.9642 76.3306 59.8572 78.4375 57.2577 78.4375H14.898C12.2983 78.4375 10.1914 76.3305 10.1914 73.7309V12.5447C10.1914 9.94501 12.2984 7.83813 14.898 7.83813H18.0358",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_550_",
    d: "M25.8809 47.0601H61.9649",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_549_",
    d: "M25.8809 54.9043H61.9649",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_548_",
    d: "M25.8809 62.7485H61.9649",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentation);
export default __webpack_public_path__ + "static/media/documentation.50352a1f309261ab80be133101ff00d5.svg";
export { ForwardRef as ReactComponent };